let state = window.history.state
let needPushState = state?state.invokeCloseDialog:true

if (needPushState) {
  window.history.replaceState({invokeCloseDialog: true}, null)
  window.history.pushState({invokeCloseDialog: false}, null);
}

window.onpopstate = function (e) {
    let invokeCloseDialog = window.history.state.invokeCloseDialog 
    if (invokeCloseDialog) {
      if (window.confirm("Вы хотите закрыть окно игры?")) {
        window.history.go(-1); 
      }
      else {
        window.history.go(1);
      }
    }
    
};